import api from 'api'
import { formatDateToImpressao } from 'util/date/formatDate'
import { defaultHandleError, downloadFile } from 'util/downloadFile'

export const downloadAtendimentoInativo = (coUnicoAtendProf: string) => {
  return api.retificacaoAtendimento
    .imprimirAtendimentoInativo({ coUnicoAtendProf })
    .then((response) => {
      downloadFile(
        new Blob([response.data], { type: 'application/pdf' }),
        `AtendimentoInativo_${formatDateToImpressao(new Date())}.pdf`
      )
      return response
    })
    .catch(defaultHandleError)
}
